import React, { Component } from 'react';
import './EmailThumbnail.scss';

export default class EmailThumbnail extends Component {
  render() {
    const { theme, footer, phone } = this.props;

    const styles = {
      page: {
        backgroundColor: theme.colors.page.backgroundColor,
      },
      slashBar: {
        backgroundColor: theme.colors.email
          ? theme.colors.email.textSecondary
          : '#3F7898',
      },
      header: {
        backgroundColor: theme.colors.email ? theme.colors.header.background : '#CF2631',
      },
      salutation: {
        color: theme.colors.email ? theme.colors.email.textPrimary : '#CF2631',
      },
      button: {
        backgroundColor: theme.colors.email ? theme.colors.email.textPrimary : '#CF2631',
        color: theme.colors.email ? theme.colors.email.buttonText : '#FFFFFF',
      },
      highlight: {
        color: theme.colors.email ? theme.colors.email.textPrimary : '#3C3C3B',
      },
      footer: {
        backgroundColor: theme.colors.email
          ? theme.colors.email.footer.backgroundColor
          : '#515151',
        color: theme.colors.email ? theme.colors.email.footer.color : '#EFEFEF',
      },
      table: {
        backgroundColor: theme.colors.email
          ? theme.colors.email.premiumBox.header.backgroundColor
          : '#828282',
      },
    };

    const quotes = [
      {
        insurerLogo:
          'https://s3-eu-west-1.amazonaws.com/jtc-prod/files/cccd1809-4878-4599-abef-5896c1370a15.png',
        insurer: 'Axiom',
        coverLevel: 'bronze',
        coverLevelText: 'Bronze',
        premium: '£5.32',
        cancellation: '£2,000',
        medicalExpenses: '£5,000,0000',
        baggageCover: '£750',
      },
      {
        insurerLogo:
          'https://s3-eu-west-1.amazonaws.com/jtc-prod/files/fb97fa37-db96-4668-bf38-d879eab6b2a8.png',
        insurer: 'Infinity',
        coverLevel: 'bronze',
        coverLevelText: 'Bronze',
        premium: '£5.86',
        cancellation: '£1,000',
        medicalExpenses: '£10,000,0000',
        baggageCover: '£1,000',
      },
      {
        insurerLogo:
          'https://s3-eu-west-1.amazonaws.com/jtc-prod/files/bd74174e-53ed-4e5b-8bd8-45f5d9c3c611.png',
        insurer: 'Unity',
        coverLevel: 'bronze',
        coverLevelText: 'Bronze',
        premium: '£6.42',
        cancellation: '£3,000',
        medicalExpenses: '£10,000,0000',
        baggageCover: '£1,500',
      },
      {
        insurerLogo:
          'https://s3-eu-west-1.amazonaws.com/jtc-prod/files/fb97fa37-db96-4668-bf38-d879eab6b2a8.png',
        insurer: 'Infinity',
        coverLevel: 'silver',
        coverLevelText: 'Silver',
        premium: '£7.04',
        cancellation: '£5,000',
        medicalExpenses: '£10,000,0000',
        baggageCover: '£2,000',
      },
      {
        insurerLogo:
          'https://s3-eu-west-1.amazonaws.com/jtc-prod/files/cccd1809-4878-4599-abef-5896c1370a15.png',
        insurer: 'Axiom',
        coverLevel: 'silver',
        coverLevelText: 'Silver',
        premium: '£7.10',
        cancellation: '£5,000',
        medicalExpenses: '£10,000,0000',
        baggageCover: '£1,500',
      },
    ];

    return (
      <div className="email-whitelabel-preview">
        <div className="wl-thumbnail-container">
          <label>Emails</label>
          <div className="wl-thumbnail">
            <div className="wl-slash-bar" style={styles.slashBar} />
            <div className="wl-header" style={styles.header}>
              <div className="wl-logo-container wl-email-logo">
                <img
                  alt="logo"
                  className="wl-logo"
                  src={theme.urls.emailLogo || theme.urls.logo}
                />
              </div>
            </div>
            <div className="wl-email-body">
              <p className="wl-email-salutation" style={styles.salutation}>
                Dear Customer
              </p>
              <p className="wl-email-text">
                Thank you for choosing Just Travel Cover for your travel insurance
                quotation. Your quote reference is NB-TVR7TB4
              </p>
              <div className="wl-email-button" style={styles.button}>
                Retrieve Quotes
              </div>
              <p className="wl-email-text-reminder" style={styles.highlight}>
                Here's a reminder of your quotations:
              </p>
              <div className="wl-email-quotes">
                <table className="wl-email-quote-table">
                  <colgroup>
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                    <col style={{ width: '20%' }} />
                  </colgroup>
                  <thead>
                    <tr style={styles.table}>
                      <th>
                        INSURANCE
                        <br />
                        PROVIDER
                      </th>
                      <th>
                        SELECT
                        <br />
                        COVER
                      </th>
                      <th>CANCELLATION</th>
                      <th>
                        MEDICAL
                        <br />
                        EXPENSES
                      </th>
                      <th>
                        BAGGAGE
                        <br />
                        COVER
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {quotes.map((quote, key) => {
                      return (
                        <tr key={key}>
                          <td className="wl-insurer">
                            <img src={quote.insurerLogo} alt={quote.insurer} />
                          </td>
                          <td className={'wl-cover wl-cover-level-' + quote.coverLevel}>
                            <span className="wl-cover-level">{quote.coverLevelText}</span>
                            <br />
                            <span className="wl-premium">{quote.premium}</span>
                          </td>
                          <td className="wl-benefit">{quote.cancellation}</td>
                          <td className="wl-benefit">{quote.medicalExpenses}</td>
                          <td className="wl-benefit">{quote.baggageCover}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <p className="wl-email-text">
                If you would like to discuss your quotation with one of our helpful staff
                call us on {phone || '0800 000 0000'}.
              </p>
            </div>
            <div className="wl-footer" style={styles.footer}>
              <p>
                {footer ||
                  'Just Insurance Agents Limited. Registered in England. Company No. 05399196\n\n' +
                    'Registered Office: Victoria House, Toward Road, Sunderland, SR1 2QF\n' +
                    'Just Insurance Agents Limited are authorised and regulated by the\n' +
                    'Financial Conduct Authority (FCA) number 610022.'}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
